import { cn } from "@/lib/utils.ts";
import { Typography } from "@backpac/monica";
import { Suspense, useState } from "react";
import type { Temporal } from "temporal-polyfill";
import { ChannelAnalyticsDashboard } from "./channel-analytics-dashboard.tsx";
import { DateRangeSelect } from "./date-range-select.tsx";

const formatDate = (date: Temporal.PlainDate) => {
  return date.toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const ChannelAnalytics = ({ className }: { className?: string }) => {
  const [selectedDateRange, setSelectedDateRange] = useState<[Temporal.PlainDate, Temporal.PlainDate] | undefined>();

  const formattedDateRange = selectedDateRange
    ? `${formatDate(selectedDateRange[0])} - ${formatDate(selectedDateRange[1])}`
    : "-";

  return (
    <div className={cn(className)}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex flex-col gap-1.5">
          <Typography size="md" weight={600} color="textPrimary">
            Key metrics
          </Typography>
          <Typography size="xs" weight={600} color="textMuted">
            {formattedDateRange}
          </Typography>
        </div>
        <DateRangeSelect onDateRangeSelected={setSelectedDateRange} selectedDateRange={selectedDateRange} />
      </div>

      <Suspense fallback={<ChannelAnalyticsDashboard.Pending />}>
        {selectedDateRange ? (
          <ChannelAnalyticsDashboard dateRange={selectedDateRange} />
        ) : (
          <ChannelAnalyticsDashboard.Pending />
        )}
      </Suspense>
    </div>
  );
};
